import { Button } from "./Button";
import "./closed-trip-notice.css";

export interface ClosedTripNoticeProps {
  /**
   * `full` = two-line notice (receipts list with receipts present);
   * `compact` = one-line (closed-trip zero-receipt empty state).
   */
  variant?: "full" | "compact";
  /**
   * Renders the inline `[ Відкрити ]` action. BA-locked default `false`
   * (variant A, prevent-only, AC-06.9). `true` (variant B) is a gated,
   * currently-OFF alternative.
   */
  showReopen?: boolean;
  /**
   * Opens the existing `ConfirmReopenTrip` `<Modal>` — does NOT reopen
   * directly. Only used when `showReopen`.
   */
  onReopen?: () => void;
}

/**
 * Read-only-state notice that replaces the add-receipt affordance on a
 * closed trip (components.md §6.4). Echoes the settle-up closed banner's
 * success colour language (same event = trip closed). See
 * `wireframes/closed-trip-add-receipt.md`.
 */
export function ClosedTripNotice({
  variant = "full",
  showReopen = false,
  onReopen,
}: ClosedTripNoticeProps) {
  return (
    <aside
      className="wp-closed-notice"
      role="status"
      data-testid="closed-trip-notice"
    >
      <span aria-hidden="true" className="wp-closed-notice__icon">
        ✓
      </span>
      <div className="wp-closed-notice__body">
        {variant === "compact" ? (
          <p className="wp-closed-notice__title">Поїздку закрито.</p>
        ) : (
          <>
            <p className="wp-closed-notice__title">
              Поїздку закрито. Чеки лише для перегляду
            </p>
            <p className="wp-closed-notice__desc">
              {showReopen
                ? "Щоб додати чек, спершу відкрий поїздку."
                : "Відкрити поїздку можна в налаштуваннях."}
            </p>
          </>
        )}
      </div>
      {showReopen ? (
        <div className="wp-closed-notice__action">
          <Button
            variant="secondary"
            size="md"
            onClick={onReopen}
            aria-label="Відкрити поїздку"
          >
            Відкрити
          </Button>
        </div>
      ) : null}
    </aside>
  );
}
